import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useAddBillModalSchema = () => {
  const { t } = useTranslation();

  return z.object({
    house: z.number({ required_error: t("common.form.field.errors.required") }),
    serviceProviderId: z.number({
      required_error: t("common.form.field.errors.required"),
    }),
  });
};

export type TAddBillModalSchema = z.infer<
  ReturnType<typeof useAddBillModalSchema>
>;
